import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { INDEXED_DB } from '@domain/constants/app-variables';
import { Cargochief } from '../cargochief/cargochief.service';

@Injectable({
	providedIn: 'root',
})
export class IndexedDBService {
	application = {
		indexedDB: {
			db: null,
		},
	};

	constructor(private cargochief: Cargochief) {
		this.getDB();
	}

	getDB() {
		var dbName = 'c4Notification',
			dbVersion = 6;
		var openRequest = indexedDB?.open(dbName, dbVersion);
		const vm = this;

		openRequest.onupgradeneeded = function (e: any) {
			// console.log("Upgrading your DB (" + dbName + ", v" + dbVersion + ")...");
			vm.updateTables(e.target.result);
		};

		openRequest.onsuccess = function (e: any) {
			vm.application.indexedDB.db = e.target.result;
		};

		openRequest.onerror = function (e) {
			console.log('Error indexedDB: ', e);
		};
		return openRequest;
	}

	updateTables(db: any) {
		Object.keys(INDEXED_DB).forEach((key) => {
			const localIndexedDB = INDEXED_DB[key];
			if (!db.objectStoreNames.contains(localIndexedDB)) {
				db.createObjectStore(localIndexedDB, { keyPath: 'id' });
			}
		});
	}

	getAll(tableName: string): Observable<any> {
		const vm = this;
		return Observable.create((observer: any) => {
			var returnData = [],
				db = this.application.indexedDB?.db,
				trans = db.transaction(tableName, 'readwrite'),
				store = trans.objectStore(tableName);
			var keyRange = IDBKeyRange.lowerBound(0),
				cursorRequest = store.openCursor(keyRange);

			trans.oncomplete = function (evt) {
				observer.next(returnData);
				observer.complete();
			};

			cursorRequest.onsuccess = function (e) {
				var result = e.target.result;
				if (!!result == false) {
					return;
				}
				returnData.push(JSON.parse(result.value.value));
				result.continue();
			};

			cursorRequest.onerror = function (error) {
				console.log(error);
			};
		});
	}

	clear(tableName: string) {
		var db = this.application.indexedDB?.db,
			trans = db.transaction('bids', 'readwrite'),
			store = trans.objectStore('bids');
		store.clear();
	}

	updateLayoutSetting(layout) {
		var transaction = this.application.indexedDB?.db.transaction(['layout'], 'readwrite');
		var store = transaction.objectStore('layout');
		var request = store.put({ id: '1', value: JSON.stringify(layout) });
		request.onerror = function (e) {
			console.log('Error', e.target.error.name);
		};
		request.onsuccess = function (e) {};
	}

	updateShowDashboardSetting(value: boolean) {
		var transaction = this.application.indexedDB?.db.transaction(
			[INDEXED_DB.DASHBOARD_SETTING],
			'readwrite'
		);
		var store = transaction.objectStore(INDEXED_DB.DASHBOARD_SETTING);
		var request = store.put({ id: this.cargochief.USER_ID, value: value });
		request.onerror = function (e) {
			console.log('Error', e.target.error.name);
		};
		request.onsuccess = function (e) {};
	}

	getShowDashboardSetting(): Observable<{ value: boolean }> {
		return new Observable((observer) => {
			var transaction = this.application.indexedDB?.db.transaction(
				[INDEXED_DB.DASHBOARD_SETTING],
				'readonly'
			);
			var store = transaction.objectStore(INDEXED_DB.DASHBOARD_SETTING);
			var request = store.get(this.cargochief.USER_ID);
			request.onerror = function (e) {
				observer.next({ value: false });
				observer.complete();
			};
			request.onsuccess = function (e) {
				observer.next(e.target.result);
				observer.complete();
			};
		});
	}

	updateShowLoadSourcingInstructions(value: boolean) {
		var transaction = this.application.indexedDB?.db.transaction(
			[INDEXED_DB.LOAD_SOURCING_INSTRUCTIONS],
			'readwrite'
		);
		var store = transaction.objectStore(INDEXED_DB.LOAD_SOURCING_INSTRUCTIONS);
		var request = store.put({ id: '1', value: value });
		request.onerror = function (e) {
			console.log('Error', e.target.error.name);
		};
		request.onsuccess = function (e) {};
	}

	getShowLoadSourcingInstructions(): Observable<{ value: boolean }> {
		return new Observable((observer) => {
			this.getDB().onsuccess = (event) => {
				this.application.indexedDB.db = (event.target as any).result;

				var transaction = this.application.indexedDB?.db.transaction(
					[INDEXED_DB.LOAD_SOURCING_INSTRUCTIONS],
					'readonly'
				);
				var store = transaction.objectStore(INDEXED_DB.LOAD_SOURCING_INSTRUCTIONS);
				var request = store.get('1');
				request.onerror = function (e) {
					observer.next({ value: false });
					observer.complete();
				};
				request.onsuccess = function (e) {
					observer.next(e.target.result);
					observer.complete();
				};
			};
		});
	}

	markDashboardAccessed() {
		var transaction = this.application.indexedDB?.db.transaction(
			[INDEXED_DB.DASHBOARD],
			'readwrite'
		);
		var store = transaction.objectStore(INDEXED_DB.DASHBOARD);
		var request = store.put({ id: new Date().getTime(), value: this.cargochief.USER_ID });
		request.onerror = function (e) {
			console.log('Error', e.target.error.name);
		};
		request.onsuccess = function (e) {};
	}
}
